// /src/pages/private/members/academyTools/components/AcademyDocumentCard.jsx

import React from 'react';
import useDocumentPreview from '../hooks/useDocumentPreview';

export default function AcademyDocumentCard({ document, onOpenDocument }) {
  const { excerpt, loadingExcerpt } = useDocumentPreview(document.documentName);

  return (
    <button
      type="button"
      className="member-academy-document-card"
      onClick={() => onOpenDocument(document)}
      data-resource="private.navbar.academy"
      data-action="read"
      data-route="/api/admin/lexical/retrieve-member-html-document"
      data-description="Academy → Open document"
    >
      <span className="member-academy-document-card__title">{document.label}</span>
      {document.version ? (
        <span className="member-academy-document-card__meta">v{document.version}</span>
      ) : null}
      <div className="member-academy-document-card__excerpt-wrap">
        {loadingExcerpt ? (
          <span className="member-academy-document-card__excerpt member-academy-document-card__excerpt--loading">
            Loading preview…
          </span>
        ) : excerpt ? (
          <p className="member-academy-document-card__excerpt">{excerpt}</p>
        ) : null}
      </div>
    </button>
  );
}
